import { client } from '@/lib/api/client'
import {
  HISTORY_PAGE_SIZE,
  venueReservationSettingHistoriesPath,
  venueReservationSettingPath,
} from '@/lib/api/config'
import { toApiError } from '@/lib/api/errors'

import type {
  VenueReservationSettingHistoryListView,
  VenueReservationSettingUpdateInput,
  VenueReservationSettingView,
} from './reservationSettingTypes'

/**
 * `GET .../reservation-setting` (#758, 백엔드 #757 §1).
 * 🚨 게이팅 없음 — 인증 미완료·조건 미충족이어도 항상 200. 403(남의 구장)·404(없는 구장)만 실패.
 */
export async function fetchVenueReservationSetting(venueId: string): Promise<VenueReservationSettingView> {
  try {
    const { data } = await client.get<VenueReservationSettingView>(venueReservationSettingPath(venueId))
    return data
  } catch (error) {
    throw toApiError(error)
  }
}

/**
 * `PUT .../reservation-setting` (#758, 백엔드 #757 §2).
 * 응답은 조회와 **같은 shape**(전환 후 상태) — 호출부가 재조회하지 않고 캐시에 직접 반영한다.
 * 🚨 켜기인데 조건 미충족이면 409(`ApiError.reservationUnmetConditions`).
 */
export async function updateVenueReservationSetting(
  venueId: string,
  input: VenueReservationSettingUpdateInput
): Promise<VenueReservationSettingView> {
  try {
    const { data } = await client.put<VenueReservationSettingView>(venueReservationSettingPath(venueId), input)
    return data
  } catch (error) {
    throw toApiError(error)
  }
}

/**
 * `GET .../reservation-setting/histories` (#758, 백엔드 #757 §3) — 커서 페이지네이션.
 * 🚨 `size` 는 항상 `HISTORY_PAGE_SIZE`(20) 로 고정한다 — 이 화면에 페이지 크기 선택 UI가 없다.
 */
export async function fetchVenueReservationSettingHistories(
  venueId: string,
  cursor?: string
): Promise<VenueReservationSettingHistoryListView> {
  try {
    const { data } = await client.get<VenueReservationSettingHistoryListView>(
      venueReservationSettingHistoriesPath(venueId),
      { params: { cursor, size: HISTORY_PAGE_SIZE } }
    )
    return data
  } catch (error) {
    throw toApiError(error)
  }
}
